import { useHierarchyArea } from '@plarium/hierarchy-react';
import React from 'react';

import { Grid, Section, MultiSelect } from '@gogame/components';
import { FormFieldArray } from '@gogame/form';

import { loadFraudProtections } from 'scenes/Campaigns/sources/fields';
import {
  FRAUD_PROTECTIONS,
  NETWORK,
} from 'scenes/Campaigns/components/Form/constants';
import FraudProtection from './FraudProtection';

function normalizeFraudProtections(value, data) {
  return value.filter((v) => data.some(({ id }) => id === v.id));
}

export const FraudProtectionArray = ({
  name = FRAUD_PROTECTIONS,
  disabledDeviceType,
  disabled,
}) => {
  const { data } = useHierarchyArea({
    name: name,
    source: loadFraudProtections,
    // active: !!(networkId && affiliateId),
    depends: [NETWORK],
    normalizeValue: normalizeFraudProtections,
  });

  return (
    <FormFieldArray name={name}>
      {({ value = [], form }) => {
        return (
          <Section title={'Fraud Protection'}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <MultiSelect
                  label={'Type'}
                  options={data}
                  disabled={disabled}
                  value={value?.map(
                    ({ fraudProtectionType }) => fraudProtectionType
                  )}
                  onChange={(_, ids) => {
                    const newValue = ids.map((id) => {
                      return (
                        value.find((v) => v.fraudProtectionType === id) || {
                          fraudProtectionType: id,
                        }
                      );
                    });
                    form.setFieldValue(name, newValue);
                  }}
                />
              </Grid>
              {value
                ?.map(({ fraudProtectionType }) =>
                  data?.find(({ id }) => id === fraudProtectionType)
                )
                .filter((c) => c)
                .map(
                  ({ name: title, osVersionEnabled, deviceTypeEnabled }, i) => {
                    const n = `${name}[${i}]`;

                    return (
                      <Grid item xs={4} key={n}>
                        <FraudProtection
                          title={title}
                          name={n}
                          withOsVersion={osVersionEnabled}
                          withDeviceType={deviceTypeEnabled}
                          disabledDeviceType={disabledDeviceType}
                          disabled={disabled}
                        />
                      </Grid>
                    );
                  }
                )}
            </Grid>
          </Section>
        );
      }}
    </FormFieldArray>
  );
};

export default FraudProtectionArray;
